// Goodacres Residential Logo - Matching brand identity
// Font: Condensed sans-serif, bold, uppercase

export const GoodacresLogo = ({ size = 48, className = "", showText = true, variant = "dark" }) => {
  const textColor = variant === "light" ? "text-white" : "text-[#1c1c1c]";
  const bgColor = variant === "light" ? "border-white" : "bg-[#1c1c1c]";
  const gColor = variant === "light" ? "text-white" : "text-white";
  
  return (
    <div className={`flex items-center gap-3 ${className}`}>
      {/* G Logo Box - Square with border */}
      <div 
        className={`flex items-center justify-center ${variant === "light" ? "border-2 border-white" : "bg-[#1c1c1c]"} ${gColor}`}
        style={{ 
          width: size, 
          height: size, 
          fontSize: size * 0.55,
          fontFamily: "'Inter', 'Arial Narrow', sans-serif",
          fontWeight: 600,
          fontStretch: "condensed"
        }}
      >
        G
      </div>
      {showText && (
        <div className="flex flex-col leading-tight">
          <span 
            className={`font-bold ${textColor} tracking-[0.15em]`}
            style={{ 
              fontSize: size * 0.35,
              fontFamily: "'Inter', 'Arial Narrow', sans-serif",
              fontStretch: "condensed"
            }}
          >
            SALES & LETTINGS
          </span>
          <span 
            className={`font-bold ${textColor} tracking-[0.2em]`}
            style={{ 
              fontSize: size * 0.28,
              fontFamily: "'Inter', 'Arial Narrow', sans-serif",
              fontStretch: "condensed"
            }}
          >
            KEMPSTON
          </span>
        </div>
      )}
    </div>
  );
};

// Smaller icon version for headers/navs
export const GoodacresIcon = ({ size = 36, className = "", variant = "dark" }) => {
  return (
    <div 
      className={`flex items-center justify-center ${variant === "light" ? "border-2 border-white text-white" : "bg-[#1c1c1c] text-white"} ${className}`}
      style={{ 
        width: size, 
        height: size, 
        fontSize: size * 0.55,
        fontFamily: "'Inter', 'Arial Narrow', sans-serif",
        fontWeight: 600
      }}
    >
      G
    </div>
  );
};

// Nav bar logo - white on dark background
export const GoodacresNavLogo = ({ className = "" }) => {
  return (
    <div className={`flex items-center gap-3 ${className}`}>
      {/* G Logo Box with white border */}
      <div 
        className="flex items-center justify-center border-2 border-white text-white"
        style={{ 
          width: 36, 
          height: 36, 
          fontSize: 20,
          fontFamily: "'Inter', 'Arial Narrow', sans-serif",
          fontWeight: 600
        }}
      >
        G
      </div>
      <div className="flex flex-col leading-tight">
        <span 
          className="text-white font-bold tracking-[0.12em]"
          style={{ 
            fontSize: 13,
            fontFamily: "'Inter', 'Arial Narrow', sans-serif"
          }}
        >
          SALES & LETTINGS
        </span>
        <span 
          className="text-white/80 font-bold tracking-[0.15em]"
          style={{ 
            fontSize: 10,
            fontFamily: "'Inter', 'Arial Narrow', sans-serif"
          }}
        >
          KEMPSTON
        </span>
      </div>
    </div>
  );
};

// Full header with location - for login page etc
export const GoodacresHeader = ({ className = "" }) => {
  return (
    <div className={`flex flex-col items-center ${className}`}>
      {/* G Logo Box */}
      <div 
        className="flex items-center justify-center bg-[#1c1c1c] text-white mb-3"
        style={{ 
          width: 64, 
          height: 64, 
          fontSize: 36,
          fontFamily: "'Inter', 'Arial Narrow', sans-serif",
          fontWeight: 600
        }}
      >
        G
      </div>
      <div className="flex flex-col items-center leading-tight">
        <span 
          className="text-[#1c1c1c] font-bold tracking-[0.15em]"
          style={{ 
            fontSize: 18,
            fontFamily: "'Inter', 'Arial Narrow', sans-serif"
          }}
        >
          SALES & LETTINGS
        </span>
        <span 
          className="text-[#1c1c1c] font-bold tracking-[0.2em] mt-0.5"
          style={{ 
            fontSize: 14,
            fontFamily: "'Inter', 'Arial Narrow', sans-serif"
          }}
        >
          KEMPSTON
        </span>
      </div>
    </div>
  );
};

export default GoodacresLogo;
